import { cn } from "@/lib/utils";

/** Short chip on a mock so it isn’t mistaken for live community content. */
export function ExamplePreviewLabel({
  className,
}: {
  className?: string;
}) {
  return (
    <span
      className={cn(
        "absolute top-2 left-2 z-10 rounded-full border border-gray-200 bg-white/95 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-gray-500 shadow-sm",
        className
      )}
    >
      Example
    </span>
  );
}

/** Caption for a marketing preview — “this is what yours could look like.” */
export function ExamplePreviewCaption({
  children = "Examples of the CertLynx experience — sample content shown",
  className,
}: {
  children?: React.ReactNode;
  className?: string;
}) {
  return (
    <p className={cn("text-[11px] font-medium text-gray-400 leading-snug", className)}>
      {children}
    </p>
  );
}
